import { Location } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { Router } from '@angular/router';

import { UI } from '../../components/ui';
import { ApiService, DynamicFormComponent } from '@mm-aggregator/drf-dynamics';
import type { EntityConfig } from '../../config/entity-config';
import { ShellRoutesService } from '../../services/shell-routes.service';
import { goBackOrNavigate } from '../../utils/navigation';

/**
 * Create page: dynamic form for new object. Submits POST to listPath.
 * Use entityConfig.createComponent for a custom form.
 */
@Component({
  selector: 'app-entity-create-page',
  standalone: true,
  imports: [DynamicFormComponent, ...UI],
  templateUrl: './entity-create-page.component.html',
})
export class EntityCreatePageComponent {
  @Input() entityConfig!: EntityConfig;

  private readonly api = inject(ApiService);
  private readonly location = inject(Location);
  private readonly router = inject(Router);
  private readonly shellRoutes = inject(ShellRoutesService);

  get listPath(): string {
    return this.entityConfig?.listPath ?? '';
  }

  get entityKey(): string {
    return this.entityConfig?.key ?? '';
  }

  goBack(): void {
    goBackOrNavigate(this.location, this.router, this.shellRoutes.commands('manage', this.entityKey));
  }

  onSubmit(value: Record<string, unknown>): void {
    if (!this.listPath) return;
    this.api.post(this.listPath, value).subscribe({
      next: (res) => {
        const rec = res as Record<string, unknown>;
        const id = rec['id'] ?? rec['pk'];
        if (id != null) {
          void this.router.navigate(this.shellRoutes.commands('manage', this.entityKey, String(id)));
        } else {
          void this.router.navigate(this.shellRoutes.commands('manage', this.entityKey));
        }
      },
      error: () => {},
    });
  }

  onCancel(): void {
    void this.router.navigate(this.shellRoutes.commands('manage', this.entityKey));
  }
}
